/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Badge_DieticianInputs */

const en_hero_badge_dietician = /** @type {(inputs: Hero_Badge_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetics`)
};

const pl_hero_badge_dietician = /** @type {(inputs: Hero_Badge_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetyka`)
};

/**
* | output |
* | --- |
* | "Dietetics" |
*
* @param {Hero_Badge_DieticianInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_badge_dietician = /** @type {((inputs?: Hero_Badge_DieticianInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Badge_DieticianInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_badge_dietician(inputs)
	return en_hero_badge_dietician(inputs)
});